// [Date, Confirmed cases, Deaths, Recovered]

export const cases = [
  ["2020-02-29", 1, 0, 0],
  ["2020-03-01", 6, 0, 0],
  ["2020-03-02", 7, 0, 0],
  ["2020-03-04", 10, 0, 0],
  ["2020-03-05", 13, 0, 0],
  ["2020-03-06", 14, 0, 0],
  ["2020-03-08", 15, 0, 0],
  ["2020-03-10", 17, 0, 0],
  ["2020-03-11", 17, 0, 0],
  ["2020-03-12", 19, 0, 0],
  ["2020-03-13", 23, 1, 0],
  ["2020-03-14", 28, 2, 0],
  ["2020-03-15", 37, 2, 0],
  ["2020-03-16", 58, 2, 0],
  ["2020-03-17", 111, 2, 0],
  ["2020-03-18", 168, 3, 0],
  ["2020-03-19", 260, 4, 3],
  ["2020-03-20", 426, 7, 3],
  ["2020-03-21", 532, 7, 3],
  ["2020-03-22", 789, 14, 3],
  ["2020-03-23", 981, 18, 3],
  ["2020-03-24", 1082, 27, 3],
  ["2020-03-25", 1211, 29, 3],
  ["2020-03-26", 1403, 34, 3],
  ["2020-03-27", 1627, 41, 3],
  ["2020-03-28", 1835, 48, 3],
  ["2020-03-29", 1924, 58, 3],
  ["2020-03-30", 1966, 62, 54],
  ["2020-03-31", 2302, 79, 58],
  ["2020-04-01", 2758, 98, 58],
  ["2020-04-02", 3163, 120, 65],
  ["2020-04-03", 3368, 145, 71],
  ["2020-04-04", 3465, 172, 100],
  ["2020-04-05", 3646, 180, 100],
  ["2020-04-06", 3747, 191, 100],
  ["2020-04-07", 3995, 220, 140],
  ["2020-04-08", 4450, 242, 140],
  ["2020-04-09", 4965, 272, 339],
  ["2020-04-10", 7161, 297, 368],
  ["2020-04-11", 7257, 315, 411],
  ["2020-04-12", 7466, 333, 501],
  ["2020-04-13", 7529, 355, 597],
  ["2020-04-14", 7603, 369, 696],
  ["2020-04-15", 7858, 388, 780],
  ["2020-04-16", 8225, 403, 838],
  ["2020-04-17", 8450, 421, 922],
  ["2020-04-18", 9022, 456, 1008],
  ["2020-04-19", 9468, 474, 1061],
];

export const other = {
  discarded: 8965,
  laboratorySamples: 31809,
};
